<template>
  <transition name="slide-x-transition" mode="out-in">
    <section class="teacher-account-settings" v-show="ready">
      <v-container class="header" fill-height>
        <v-row justify="space-between" class="mb-2">
          <v-col cols="12">
            <h1 class="header-title optus-highlight optus-highlight--yellow">
              Frequently Asked Questions&nbsp;
            </h1>
            <!-- <search class="mt-3" /> -->
            <faq class="mt-3" :faqs="faqs" />
            <send-question class="mt-3" :questions="questions" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </transition>
</template>

<script>
import Faq from '@/modules/support/views/Faq'
import SendQuestion from '@/modules/support/views/SendQuestion'
import { mapState } from 'vuex'

export default {
  name: 'Support',
  components: {
    //Search,
    Faq,
    SendQuestion
  },
  data() {
    return {
      ready: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  computed: {
    ...mapState(['lessonTerm']),
    questions() {
      return [
        {
          text: 'General',
          value: 'general'
        },
        {
          text: 'Children',
          value: 'children'
        },
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}`,
          value: 'workshop'
        },
        {
          text: 'View results and graphs',
          value: 'marks_graphs'
        }
      ]
    },
    faqs() {
      return [
        {
          title: 'General',
          type: 'general',
          items: [
            {
              question: `Is there a time limit on each ${this.lessonTerm}?`,
              answer: `No. You have access to all ${this.lessonTerm}s for an unlimited time, and so do your children.`
            }
          ]
        },
        {
          title: 'Adding and deleting children',
          type: 'child',
          items: [
            {
              question: 'How do I delete a children from my dashboard?',
              answer:
                'In the ‘Children’ section, select which child you would like to manage. This will lead you to the child’s individual page. Once on this page, you can unenrol the child.'
            }
          ]
        },
        {
          title: 'Adding and deleting children',
          type: 'child',
          items: [
            {
              question:
                'I want to see a child’s results, where can I view them?',
              answer: `In the ‘Classes’ section, select which child you would like to manage. This will lead you to the child’s individual page. Once on this page, you can view all of the child’s results from the ${this.lessonTerm}s they have completed.`
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>
